import axios from 'axios';

// development > homolog > production

const environments = {
  development: process.env.REACT_APP_BASE_URL_DEV,
  homolog: process.env.REACT_APP_BASE_URL_HML,
  production: process.env.REACT_APP_BASE_URL,
};

const api = axios.create({
  baseURL: environments[process.env.REACT_APP_ENV],
});

api.defaults.headers['Accept-Language'] = 'pt-BR';

export default api;
